var _rect, _g, _path, _path2, _path3, _path4, _path5, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValue02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.5044,
    y: 33.3726,
    width: 72.9288,
    height: 70.7838,
    rx: 5,
    transform: "rotate(10.8671 44.5044 33.3726)",
    fill: "url(#paint0_linear_603_1248)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_603_1248)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 86,
    height: 83,
    rx: 5,
    fill: "url(#paint1_linear_603_1248)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 13.5,
    width: 85,
    height: 82,
    rx: 4.5,
    stroke: "url(#paint2_linear_603_1248)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 90C29.3431 90 28 88.6569 28 87L28 68C28 66.3431 29.3431 65 31 65V65C32.6569 65 34 66.3431 34 68L34 87C34 88.6569 32.6569 90 31 90V90Z",
    fill: "url(#paint3_linear_603_1248)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90C42.3431 90 41 88.6569 41 87L41 59C41 57.3431 42.3431 56 44 56V56C45.6569 56 47 57.3431 47 59L47 87C47 88.6569 45.6569 90 44 90V90Z",
    fill: "url(#paint4_linear_603_1248)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90C55.3431 90 54 88.6569 54 87L54 69C54 67.3431 55.3431 66 57 66V66C58.6569 66 60 67.3431 60 69L60 87C60 88.6569 58.6569 90 57 90V90Z",
    fill: "url(#paint5_linear_603_1248)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90C81.3431 90 80 88.6569 80 87L80 69C80 67.3431 81.3431 66 83 66V66C84.6569 66 86 67.3431 86 69L86 87C86 88.6569 84.6569 90 83 90V90Z",
    fill: "url(#paint6_linear_603_1248)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70 90C68.3431 90 67 88.6569 67 87L67 59C67 57.3431 68.3431 56 70 56V56C71.6569 56 73 57.3431 73 59L73 87C73 88.6569 71.6569 90 70 90V90Z",
    fill: "url(#paint7_linear_603_1248)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_603_1248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 18C83.1716 18 82.5 18.6716 82.5 19.5C82.5 20.3284 83.1716 21 84 21V21C84.7765 21 85.1654 21.9389 84.6163 22.488L69.5221 37.5822C66.5695 40.5348 62.0602 41.2701 58.3226 39.4083L47.2358 33.8859C46.537 33.5379 45.6996 33.6282 45.0911 34.1173L25.5425 49.8295C24.6816 50.5215 24.5446 51.7804 25.2366 52.6413C25.9286 53.5023 27.1875 53.6392 28.0484 52.9473L41.6075 42.0492C44.6498 39.6038 48.8369 39.1522 52.3308 40.8925L64.0842 46.747C64.8538 47.1303 65.7822 46.9789 66.3902 46.371L87.2098 25.5514C88.0549 24.7062 89.5 25.3048 89.5 26.5V26.5C89.5 27.3284 90.1716 28 91 28C91.8284 28 92.5 27.3284 92.5 26.5V19.5C92.5 18.6716 91.8284 18 91 18H84Z",
    fill: "url(#paint8_linear_603_1248)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_603_1248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7584 44.957C70.7584 48.2292 68.1632 50.8809 64.9756 50.8809C61.7881 50.8809 59.1929 48.2292 59.1929 44.957C59.1929 41.6848 61.7881 39.0332 64.9756 39.0332C68.1632 39.0332 70.7584 41.6848 70.7584 44.957Z",
    fill: "url(#paint9_linear_603_1248)",
    shapeRendering: "geometricPrecision"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_603_1248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5656 36.4238C52.5656 39.696 49.9704 42.3476 46.7828 42.3476C43.5952 42.3476 41 39.696 41 36.4238C41 33.1516 43.5952 30.5 46.7828 30.5C49.9704 30.5 52.5656 33.1516 52.5656 36.4238Z",
    fill: "url(#paint10_linear_603_1248)",
    shapeRendering: "geometricPrecision"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bd_603_1248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5656 50.4238C33.5656 53.696 30.9704 56.3476 27.7828 56.3476C24.5952 56.3476 22 53.696 22 50.4238C22 47.1516 24.5952 44.5 27.7828 44.5C30.9704 44.5 33.5656 47.1516 33.5656 50.4238Z",
    fill: "url(#paint11_linear_603_1248)",
    shapeRendering: "geometricPrecision"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_603_1248",
    x: 9,
    y: 9,
    width: 94,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_603_1248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_603_1248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_603_1248",
    x: 20.7954,
    y: 18,
    width: 75.7046,
    height: 43.3887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_603_1248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_603_1248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_603_1248",
    x: 55.1929,
    y: 35.0332,
    width: 19.5657,
    height: 23.8477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_603_1248"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_603_1248",
    result: "effect2_dropShadow_603_1248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_603_1248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_603_1248",
    x: 37,
    y: 26.5,
    width: 19.5657,
    height: 23.8477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_603_1248"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_603_1248",
    result: "effect2_dropShadow_603_1248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_603_1248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bd_603_1248",
    x: 18,
    y: 40.5,
    width: 19.5657,
    height: 23.8477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_603_1248"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_603_1248",
    result: "effect2_dropShadow_603_1248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_603_1248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_1248",
    x1: 80.9688,
    y1: 33.3726,
    x2: 80.9688,
    y2: 104.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_1248",
    x1: 56,
    y1: 13,
    x2: 56,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_603_1248",
    x1: 99,
    y1: 93.5,
    x2: -3.50001,
    y2: -6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416667,
    stopColor: "#BCABF7",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E86F4",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_603_1248",
    x1: 36,
    y1: 67.5,
    x2: 24.4146,
    y2: 76.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_603_1248",
    x1: 49,
    y1: 59.4,
    x2: 34.8843,
    y2: 67.7033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_603_1248",
    x1: 62,
    y1: 68.4,
    x2: 50.7869,
    y2: 77.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_603_1248",
    x1: 88,
    y1: 68.4,
    x2: 76.7869,
    y2: 77.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_603_1248",
    x1: 75,
    y1: 59.4,
    x2: 60.8843,
    y2: 67.7033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_603_1248",
    x1: 58.6477,
    y1: 18,
    x2: 58.6477,
    y2: 53.3885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#6C44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#997DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_603_1248",
    x1: 64.9757,
    y1: 39.0332,
    x2: 64.9757,
    y2: 50.8808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_603_1248",
    x1: 46.7828,
    y1: 30.5,
    x2: 46.7828,
    y2: 42.3476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_603_1248",
    x1: 27.7828,
    y1: 44.5,
    x2: 27.7828,
    y2: 56.3476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.62
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue02);
export default __webpack_public_path__ + "static/media/value-02.5fc40dbac55545872a5ee76527eddedd.svg";
export { ForwardRef as ReactComponent };